import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import { LoadingIcon } from '../Common/Loading_Icon';
import { checkAuthenticated, setUserSession } from '../../Actions/userSessionActions'
import { Trans } from 'react-i18next';

class ResetPasswordOverlay extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            loading_page: true,
            page_info: {},
            current_password: null,
            password: null,
            password_confirmation: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.submitAction = debounce(this.submitAction.bind(this), 500);

    }

    componentDidMount() {
        var profile_id = this.props.userSession.user.profile_id;

        if (this.props.match.params.id) {
            profile_id = this.props.match.params.id;
        }

        var self = this;
        axios.get('/ajax/password/' + profile_id)
        .then(function(response) {
            self.setState({
                loading_page: false,
                page_info: response?.data
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        })
    }

    componentWillReceiveProps(nextProps) {
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    submitAction() {
        var profile_id = this.props.userSession.user.profile_id;

        if (this.props.match.params.id) {
            profile_id = this.props.match.params.id;
        }

        var self = this;
        
        axios({
            method: 'post',
            url: '/ajax/password/' + profile_id + '/update',
            data: {
                    id: profile_id,
                    current_password: this.state.current_password,
                    password: this.state.password,
                    password_confirmation: this.state.password_confirmation
                 },
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(function(response) {
            self.props.history.goBack();
            showStatusMsg(response?.data.message, 'success');
            self.props.dispatch(checkAuthenticated())
            var current_user = self.props.userSession.user
            current_user.temp_password = false;
            self.props.dispatch(setUserSession(current_user))
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render(props) {
        if(!this.state.loading_page) {
            return (
                <div id = "changepassword-overlay">
                    <div className = "card">
                        <div className = "card-divider">
                            <span className = "card-header-title"><Trans>Change Password</Trans></span>
                            <button className="close-button" onClick={this.props.history.goBack} type='button'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className = "card-section">
                            <input type='hidden' name='user_id' id='user_id' defaultValue={this.state.page_info.id} />
                            <div className = "row">
                                <label><Trans>Current Password</Trans>
                                    <input type = "password" name="current_password" id="current_password" disabled={this.state.page_info.view.disabled.current_password} onChange={this.handleChange}/>
                                </label>
                            </div>
                            <div className = "row">
                                <label><Trans>New Password</Trans>
                                    <input type = "password" name="password" id="password" onChange={this.handleChange} />
                                </label>
                            </div>
                            <div className = "row">
                                <label><Trans>Confirm New Password</Trans>
                                    <input type = "password" name="password_confirmation" id="password_confirmation" onChange={this.handleChange} />
                                </label>
                            </div>
                        </div>
                        <div className = "card-section">
                            <div className = "button-group float-right">
                                <a className = "button mr-8" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a>
                                <a className = "button primary" onClick={this.submitAction}><Trans>Change Password</Trans></a>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(ResetPasswordOverlay)